import Konva from 'konva';
import { v4 as uuidv4 } from 'uuid';

import HaspObject from './HaspObject';
import { processIconText } from '../utils/iconFonts';

// options	string	""	List of items separated by \n
// val	    int16	0	The number of the selected item
// text	    string	""	Read-only The text of the selected item
// rows	    int8	3	The number of rows that are visible
//                      Use this property instead of h to set object height
// mode	    0..1	0	Roller mode: 0 = normal (finite), 1 = infinite
// align	string	center	Text alignment: left, center, right

// selected.bg_color is the selected item bar in the middle

export const ROLLER_ALIGN_OPTIONS = [
    { value: 'Left', description: 'Left' },
    { value: 'center', description: 'center' },
    { value: 'right', description: 'right' },
];

export const ROLLER_MODE_OPTIONS = [
    { value: 0, description: 'normal' },
    { value: 1, description: 'infinite' },
];

export default class HaspRoller extends HaspObject {

    hasp_align_options = ROLLER_ALIGN_OPTIONS;
    hasp_mode_options = ROLLER_MODE_OPTIONS;
    // itemHeight = 30;

    constructor(config) {
        // config.height ??= 60;
        super(config);
        this.loadOptions(config.options);
        this.haspid = config.haspid;
        this.minWidth = 100;
        this.minHeight = 60;
        // this.setBgColor(this.theme.primary_color);
        this.drawOptions();

        this.on('transform', (e) => { this.drawOptions(); });
        this.on('transformend', (e) => { this.drawOptions(); });

        this.onStyle('main', 'bg_color', () => { this.rect.fill(this.style('main').bg_color); })
        this.onStyle('main', 'text_color', () => { this.drawOptions(); })
        this.onStyle('selected', 'bg_color', () => { this.selectRect.fill(this.style('selected').bg_color); })
        this.onStyle('selected', 'text_color', () => { this.drawOptions(); })

        this.onStyle('main', 'text_font', () => { this.drawOptions(); });
        this.on('text_align', (e) => {
            this.drawOptions();
        });
    }

    redraw(args) {
        this.drawOptions();
    }

    setNewSize(size) {
        super.setNewSize(size);
        this.drawOptions();
    }

    drawOptions() {
        if (this.labelGroup !== undefined)
            this.labelGroup.destroy()

        const main = this.style('main');
        const selected = this.style('selected');
        const stepY = main.text_font * 1.82;
        const w = this.rect.width() - 6;

        if (this.rect.height() > this.listOptions.length * stepY) {
            this.height(this.listOptions.length * stepY)
            this.rect.height(this.listOptions.length * stepY)
        }

        this.rows = Math.round(this.rect.height() / stepY);

        this.labelGroup = new Konva.Group({
            x: 0,
            y: 0,
            width: this.rect.width(),
            height: this.rect.height(),
        })

        //color rectangle in the middle
        const middleTop = (this.rect.height() / 2) - (stepY / 2);
        this.selectRect = new Konva.Rect({
            id: uuidv4(),
            x: 0,
            y: middleTop,
            width: this.rect.width(),
            height: stepY,
            fill: selected.bg_color,
            draggable: false,
            obj: 'select_rect',
            selectable: false,
            listening: false
        });
        this.labelGroup.add(this.selectRect);


        for (var index = 0; index < this.rows && index < this.listOptions.length; index++) {
            const option = this.listOptions[index];
            // let config = { x: 3, y: index * stepY, width: w, height: stepY, obj: 'optionlabel', text: option, 'align': 'center' };
            var tcol = main.text_color;
            const typos = index * stepY;
            // if (typos > middleTop && typos < (middleTop + stepY)) {
            //     tcol = this.style('selected').text_color;
            // }
            const label = new Konva.Text({
                id: uuidv4(),
                x: 3,
                y: typos,
                width: w,
                height: stepY,
                obj: 'optionlabel',
                verticalAlign: 'middle',
                text: processIconText(option),
                fontSize: main.text_font,
                fontFamily: 'Roboto Condensed',
                align: this.align,
                fill: tcol,
                listening: false,
                strokeWidth: 1,
            });
            label.noExport = true;
            this.labelGroup.add(label);
        }
        this.add(this.labelGroup);
    }


    /**
     * Iterate the config options and for every \n char
     * we create a new item
     * @param {*} options 
     */
    loadOptions(options) {
        if (options) {
            this.listOptions = [];
            const opt_list = options.split('\n')
            opt_list.forEach(option => {
                if (option !== '\n') { //new row for every \n char
                    this.listOptions.push(option)
                }
            });
        }
    }

    objectExport(page, objectData) {
        //use /n to identify new line
        objectData.options = this.listOptions.join('\n');
        objectData.rows = this.rows;
        objectData.h = undefined;
    }

}
